module.exports = __webpack_public_path__ + "img/解决方案_节能_绿.3afa5f25.svg";